import { z } from "zod";

export const recommendationFeedbackScopeSchema = z.enum([
  "global", "breakfast", "lunch", "dinner", "snack",
]);

const identity = { operationId: z.string().uuid() };
const target = {
  recipeId: z.string().min(1).max(200),
  scope: recommendationFeedbackScopeSchema,
};

// The authenticated session supplies the actor. Transient skips, effort and
// ingredient feedback cannot enter the lasting-suppression mutation boundary.
export const recommendationFeedbackMutationSchema = z.discriminatedUnion("action", [
  z.object({ ...identity, ...target, action: z.literal("suppress") }).strict(),
  z.object({
    ...identity, ...target, action: z.literal("restore"),
    // Undo must not erase a newer explicit choice from another tab/device.
    expectedRevisionId: z.string().uuid().optional(),
  }).strict(),
  z.object({ ...identity, action: z.literal("reset") }).strict(),
]);

export type RecommendationFeedbackScope = z.infer<typeof recommendationFeedbackScopeSchema>;
export type RecommendationFeedbackMutation = z.infer<typeof recommendationFeedbackMutationSchema>;
